module.exports = __webpack_public_path__ + "static/decisioningos-pmg-main-mobile-60368e7c2279371ac87727ec7dfa3256.png";